import {
  ButtonLink,
  IconRocket,
  TooltipRenderer,
  Text,
  useResponsiveValue,
} from 'braid-design-system';
import { useEffect, type FC } from 'react';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';

interface FreemiumButtonProps {
  link: string;
  onFreemiumButtonLoaded: () => void;
  onFreemiumButtonClicked: () => void;
}

export const FreemiumButton: FC<FreemiumButtonProps> = ({
  link,
  onFreemiumButtonLoaded,
  onFreemiumButtonClicked,
}: FreemiumButtonProps) => {
  const { t } = useTranslations(translations);
  const responsiveValue = useResponsiveValue();

  useEffect(() => {
    onFreemiumButtonLoaded();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TooltipRenderer
      id="tooltip-freemium-explanation"
      tooltip={
        <Text>{t('Upgrade your ad for up to 3X more applications')}</Text>
      }
      placement="bottom"
    >
      {({ triggerProps }) => (
        <ButtonLink
          size={
            responsiveValue({ mobile: 'small', tablet: 'standard' }) ??
            'standard'
          }
          href={link}
          onClick={onFreemiumButtonClicked}
          icon={<IconRocket />}
          tone="brandAccent"
          {...triggerProps}
        >
          {t('Upgrade')}
        </ButtonLink>
      )}
    </TooltipRenderer>
  );
};
